import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppConfigService } from 'app-config';
import { Store } from '@ngrx/store';
import { AppState } from './../../core/app.states';
import { Observable } from 'rxjs';

export class UserInfo{
	public elssHeaderItemViewConditions: Array<string>;
	public elssHeaderItemViewPermissions: Array<string>;
	public firstName: string;
	public isCAPStaff: boolean;
	public isCommitteeMember: boolean;
	public lastName: string;
	public loaded: boolean;
	public loading: boolean;
	public role: boolean;
	public userMemberId: string;
	public userName: string;
}

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	public envName: string = '';
	public userInfo: UserInfo = new UserInfo();
	public logOutURL = AppConfigService.settings.apiServer.logoutUrl;
	public getState: Observable<any>;

	constructor(private store$: Store<AppState>, private cdref: ChangeDetectorRef) {
		this.getState = this.store$.select('userInfoState');
	}

	ngOnInit(): void {
		// TO GET THE ENV NAME.
		this.envName = AppConfigService.settings.env.name;

		// TO GET THE USER DATA AND PERMISSION FROM STORE.
		this.getState.subscribe( (state: UserInfo) => {
			this.userInfo = state;
			this.cdref.detectChanges();
		});
	}
}